import {z} from 'zod'

import {AlignEnum, CreateOrUpdateBlockKeyValueTableDocument} from '@sdox/api'

import {EditorFeature} from '../../../../inputs/TipTap/types'
import {createMetaSchema} from '../../utils/getCreateMetaFromFieldValues'
import {createFormConfig} from '../../utils/createFormConfig'
import {i18nValidation} from '../../../../../i18n'

import type {BlockKeyValueTableInput, CreateOrUpdateBlockKeyValueTableMutation} from '@sdox/api'

type CreateKeyValueTableValidatorSchema = z.infer<typeof createKeyValueTableValidatorSchema>

const createKeyValueTableValidatorSchema = z.object({
  data: z.object({
    alignValue: z.nativeEnum(AlignEnum),
    keyValues: z.array(
      z.object({
        key: z.string().min(1, {message: i18nValidation.enterText}),
        value: z.string().min(1, {message: i18nValidation.enterText}),
      }),
    ).min(1),
  }),
  meta: createMetaSchema,
})

export const keyValueTableConfig = createFormConfig<
  CreateKeyValueTableValidatorSchema,
  CreateOrUpdateBlockKeyValueTableMutation,
  BlockKeyValueTableInput
>({
  mutationOptions: {
    mutation: CreateOrUpdateBlockKeyValueTableDocument,
  },
  validatorSchema:createKeyValueTableValidatorSchema,
  fieldMapper: (fieldValues) => ({
    alignValue: fieldValues.data.alignValue,
    keyValues: fieldValues.data.keyValues,
  }),
  inputFields: [
    {
      label: 'Textausrichtung der Values',
      fieldName: 'data.alignValue',
      inputType: 'select',
      defaultValue: AlignEnum.End,
      options: [
        {label: 'Links', value: AlignEnum.Start},
        {label: 'Rechts', value: AlignEnum.End},
      ],
      required: true,
    },
    {
      label: 'Key Value Paar',
      fieldName: 'data.keyValues',
      inputType: 'array',
      fields: [
        {
          label: 'Key',
          fieldName: 'key',
          inputType: 'text',
          defaultValue: '',
          required: true,
          placeholder: 'Titel',
        },
        {
          label: 'Value',
          fieldName: 'value',
          inputType: 'richtext',
          editorConfig: {
            isSmall: true,
            spanAsParagraph: true,
            features: [
              EditorFeature.nobreak,
              EditorFeature.footnote,
            ],
          },
          required: true,
          placeholder: 'Value',
        },
      ],
      required: true,
    },
  ],
})
